import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ModalCargando from '../utilsComponentes/ModalCargando';
import ItemSucursalTms from './ItemSucursalTms';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function ReporteTmsFreidoras() {
    const {loading,setLoading} = useContext(ContextGloball)
    const [regional,setRegional] = useState('990');
    const [actualizar,setActualizar] = useState(false);
    const [sucursales,setSucursales] = useState([]);
    const [idSucursal,setIdSucursal] = useState('');
    const [selectSuc,setSelectSuc] = useState({});
    const [aceites,setAceites] = useState([]);
    function getSucursales() {
        setLoading(true);
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    setSucursales(data.ok)
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function cambioSucursal(idSuc){
        var suc = sucursales.filter((item)=>item.ID_SUCURSAL==idSuc);
        setSelectSuc(suc[0]);
        setIdSucursal(idSuc);
        getAceiteSucursal(idSuc);
    }
    function getAceiteSucursal(dato) {
        fetch(`${server}/reporte/getAceiteSucursal`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional,'idSucursal':dato
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setAceites(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    useEffect(()=>{
        getSucursales();
        if(idSucursal!==''){
            setSelectSuc({});
            setIdSucursal('');
            //desconectarme Sucursal Antigua
        }
    },[regional])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient p-1'>
                <div className='row row-cols g-1'>
                    <div className='col' style={{ maxWidth: '170px', minWidth: '170px' }}>
                        <div className="input-group input-group-sm my-auto">
                            <span className="input-group-text bg-secondary bg-gradient text-light" >Regional</span>
                            <select className=" form-select text-center "
                                value={regional} onChange={(e) => setRegional(e.target.value)}
                            >
                                <option value='990'>CBBA</option>
                                <option value='991'>SCRZ</option>
                            </select>
                        </div>
                    </div>
                    <div className='col'style={{ maxWidth: '190px',minWidth: '190px' }}>
                    <div className="input-group input-group-sm my-auto mx-2">
                        <span className="input-group-text bg-secondary bg-gradient text-light" >Sucursal</span>
                        <select className=" form-select text-center "
                            value={idSucursal} onChange={(e) => cambioSucursal(e.target.value)}
                        >   
                            <option value=''>NINGUNO</option>
                            {sucursales.map((item,index)=>{
                                return(
                                    <option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>
                                )
                            })}
                        </select>
                    </div>
                    </div>
                    <div className='col' style={{ maxWidth: '100px' }}>
                        <button className='btn btn-success btn-sm w-100' onClick={() => setActualizar(!actualizar)}>Actualizar</button>
                    </div>
                </div>
            </div>
            {idSucursal!==''&&<div className='py-1'>
                <ItemSucursalTms sucursal={selectSuc} aceites={aceites} setLoading={setLoading} actualizar={actualizar}/>
            </div>}
        </>
    )
}

export default ReporteTmsFreidoras